import React from 'react';

interface InjuryMechanismProps {
  data: {
    mechanism: string;
    high_energy: boolean;
    time_since_injury_hours: number | null;
    work_related: boolean;
    circumstances: string;
  };
  onChange: (field: string, value: any) => void;
}

const MECHANISM_OPTIONS = [
  { value: '', label: 'Seleccionar...' },
  { value: 'trauma directo', label: 'Trauma Directo' },
  { value: 'trauma indirecto', label: 'Trauma Indirecto' },
  { value: 'caída misma altura', label: 'Caída Misma Altura' },
  { value: 'caída altura', label: 'Caída de Altura' },
  { value: 'accidente tránsito', label: 'Accidente Tránsito' },
  { value: 'deportiva', label: 'Deportiva' },
  { value: 'arma fuego', label: 'Arma de Fuego' },
  { value: 'arma blanca', label: 'Arma Blanca' },
  { value: 'aplastamiento', label: 'Aplastamiento' },
  { value: 'otros', label: 'Otros' },
];

const InjuryMechanism: React.FC<InjuryMechanismProps> = ({ data, onChange }) => {
  return (
    <div className="card mb-3">
      <div className="card-body">
        <h5 className="card-title">
          <i className="fa fa-car-crash me-1"></i>
          Mecanismo de Lesión
        </h5>
        <div className="row mt-3">
          <div className="col-md-6">
            <div className="mb-3">
              <label className="form-label">Mecanismo</label>
              <select
                className="form-select"
                value={data.mechanism}
                onChange={e => onChange('mechanism', e.target.value)}
              >
                {MECHANISM_OPTIONS.map(o => (
                  <option key={o.value} value={o.value}>{o.label}</option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-md-3">
            <div className="mb-3">
              <label className="form-label">Tiempo desde Lesión (horas)</label>
              <input
                type="number"
                className="form-control"
                min={0}
                value={data.time_since_injury_hours ?? ''}
                onChange={e => onChange('time_since_injury_hours', e.target.value ? Number(e.target.value) : null)}
                placeholder="Horas"
              />
            </div>
          </div>
          <div className="col-md-3 d-flex align-items-end">
            <div className="mb-3 w-100">
              <div className="d-flex gap-4">
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="high_energy"
                    checked={data.high_energy}
                    onChange={e => onChange('high_energy', e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor="high_energy">
                    Alta Energía
                  </label>
                </div>
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="work_related"
                    checked={data.work_related}
                    onChange={e => onChange('work_related', e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor="work_related">
                    Relacionado a Trabajo
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="mb-3">
              <label className="form-label">Circunstancias</label>
              <textarea
                className="form-control"
                rows={2}
                value={data.circumstances}
                onChange={e => onChange('circumstances', e.target.value)}
                placeholder="Describa las circunstancias de la lesión..."
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InjuryMechanism;
